import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PersonCheckIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "PersonCheck",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M19.86 29.29c-.3 0-.59-.12-.81-.33l-3.44-3.44a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l2.61 2.61 7.2-7.64a1.15 1.15 0 0 1 1.62-.05c.46.43.48 1.16.05 1.62l-8.01 8.49c-.21.22-.51.35-.82.36zM14.14 15.57c-3.78 0-6.86-3.08-6.86-6.86s3.08-6.85 6.86-6.85S21 4.94 21 8.72s-3.08 6.86-6.86 6.86Zm0-11.43c-2.52 0-4.57 2.05-4.57 4.57s2.05 4.57 4.57 4.57 4.57-2.05 4.57-4.57-2.05-4.57-4.57-4.57"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 29.29c-.63 0-1.14-.51-1.14-1.14 0-5.67 4.61-10.29 10.29-10.29 2.33 0 4.62.8 6.43 2.26.49.39.57 1.11.18 1.61-.39.49-1.11.57-1.61.18a7.9 7.9 0 0 0-5-1.75c-4.41 0-8 3.59-8 8 0 .63-.51 1.14-1.14 1.14Z"
    }), /*#__PURE__*/_jsx("path", {
      "fill-rule": "evenodd",
      d: "M11.85 27.6",
      opacity: ".3"
    })]
  }));
};
PersonCheckIcon.displayName = 'PersonCheckIcon';